import { Box, Typography } from "@mui/material";
import { useContext } from "react";
import CustomButton from "../../../UIElements/CustomButton";
import { SignUpContext } from "../../../../contexts";
import "../../../components-styles.scss";
import EstablishmentCategoryFormWrapper from "../../../Common/EstablishmentCategoryFormWrapper";

type EstablishmentCategoryFormProps = {
    goto: (step: number) => void;
    nextStep: number;
};

export default function EstablishmentCategoryForm({
    goto,
    nextStep,
}: EstablishmentCategoryFormProps) {
    const { updateSignupForm, ...signupForm } = useContext(SignUpContext);

    const onSubmit = (data: any) => {
        updateSignupForm({
            ...signupForm,
            step: nextStep,
            signupUser: {
                ...signupForm.signupUser,
                establishment: {
                    ...signupForm.signupUser.establishment,
                    ...data,
                },
            },
        });
        goto(nextStep);
    };
    return (
        <Box className="signup-form-root">
            <Box className="signup-form-title-container">
                <Typography className="signup-form-title">
                    Type d’établissement
                </Typography>
                <Typography className="signup-form-sub-title">
                    Renseignez les informations relatives à votre établissement
                </Typography>
            </Box>
            <EstablishmentCategoryFormWrapper
                onSubmit={onSubmit}
                defaultValues={{
                    region:
                        signupForm?.signupUser?.establishment
                            ?.region ?? "",
                    establishmentType:
                        signupForm?.signupUser?.establishment
                            ?.establishmentType ?? "",
                    establishmentGroup:
                        signupForm?.signupUser?.establishment
                            ?.establishmentGroup ?? "",
                }}
                formActionComponents={{
                    submit: (
                        <CustomButton
                            type="submit"
                            label="Étape suivante"
                            customsx={{
                                marginLeft: "auto",
                                marginRight: "auto",
                                marginTop: "3.5rem",
                                marginBottom: "auto",
                            }}
                        />
                    ),
                }}
            />
        </Box>
    );
}
